<template>
  <div>
    <b-container>
      <b-row v-for="daData in daDataList" :key="daData.title">
        <b-col cols="12">
          <data-availability
            :uniqueName="daData.uniqueKey"
            :data="daData.data"
            :title="daData.title"
          ></data-availability>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// Eslint disabled for the variable 'instrument_title'
/* eslint-disable camelcase */

// Eslint disabled for all lodash methods
/* eslint-disable no-undef */

// Eslint disabled for no return statement in showModal()
/* eslint-disable array-callback-return */

import axios from 'axios';
import DACalendar from './DACalendar';
import { APIBASEURL, APIDA, APIMETADATA } from '../utils/constants';

export default {
  props: ['refdes'],
  components: {
    'data-availability': DACalendar,
  },
  data() {
    return {
      daDataList: [],
      title: '',
    };
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      const request = {
        ref: this.refdes,
      };
      axios
        .get(`${APIBASEURL}/${APIMETADATA}/${APIDA}`, {
          params: request,
        })
        .then((resp) => {
          this.showModal(resp.data);
        });
    },
    showModal(data) {
      const ref = this.refdes;
      const keys = _.keys(data);
      keys.map((key) => {
        if (key.toLowerCase().includes(ref.toLowerCase())) {
          this.daDataList = [
            {
              title: ref,
              uniqueKey: key,
              data: data[key],
            },
          ];
        }
      });
    },
  },
};
</script>
